exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._context-menu {\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 4px;\n}\n._context-menu ul {\n  width: 100px;\n  padding: 5px 0;\n  list-style: none;\n}\n._context-menu ul .list-item {\n  cursor: default;\n  color: #333;\n  padding: 0 10px;\n}\n._context-menu ul .list-item:hover {\n  background: #4b8de4;\n  color: #fff;\n}\n._context-menu ul .list-item.disabled {\n  color: #999;\n}\n._context-menu ul .divide {\n  border-top: 1px solid #ccc;\n  margin: 5px;\n}\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/context-menu.vue
 ** module id = 102
 ** module chunks = 0
 **/